import { EWatchlistFilter } from '@webtrader/core/api/market/watchlist';
import mixpanel from '@webtrader/core/mix-panel';
import { EMixpanelEventNames, EMixpanelProperties, EPage } from '@webtrader/core/services/analysis/constants';
import { eventNameHelper, eventPropertiesHelper, userHelper } from '@webtrader/core/services/analysis/helpers';
import { EThemeScheme } from '@webtrader/core/themes';

import { IActionClickProps } from './type';

class PageAnalysisService {
  public trackPageView = (page: string) => {
    mixpanel.registerSuperProperties({
      [EMixpanelProperties.PAGE]: page
    });
  };

  public pageClick = (page: EPage | undefined) => {
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(EMixpanelEventNames.PAGE_CLICKED, {
      [EMixpanelProperties.PAGE]: page ?? '-',
      ...userAccountProperties
    });
  };

  public pageFullChartClick = (symbol: string) => {
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(EMixpanelEventNames.PAGE_FULL_CHART_CLICKED, {
      [EMixpanelProperties.SYMBOL]: symbol ?? '-',
      ...userAccountProperties
    });
  };

  public actionClick = ({ action, symbol }: IActionClickProps) => {
    const eventName = eventNameHelper.mapActionClickEventName(action);
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(eventName, {
      [EMixpanelProperties.SYMBOL]: symbol ?? undefined,
      ...userAccountProperties
    });
  };

  public watchlistClick = (watchList: EWatchlistFilter) => {
    const watchLists = eventPropertiesHelper.mapWatchListEventProperties(watchList);
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(EMixpanelEventNames.WATCHLIST_CLICKED, {
      [EMixpanelProperties.WATCHLIST_TYPE]: watchLists ?? '-',
      ...userAccountProperties
    });
  };

  public appearancePreferenceClick = (themeScheme: EThemeScheme) => {
    const themeSchemes = eventPropertiesHelper.mapThemeSchemeEventProperties(themeScheme);
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(EMixpanelEventNames.APPEARANCE_PREFERENCE_CLICKED, {
      [EMixpanelProperties.APPEARANCE_PREFERENCE]: themeSchemes ?? '-',
      ...userAccountProperties
    });
  };

  public confirmLinkAccountClick = (newWetatraderID: string | undefined) => {
    const userAccountProperties = userHelper.createUserAccountProperties();
    mixpanel.track(EMixpanelEventNames.CONFIRM_LINK_ACCOUNT_CLICKED, {
      [EMixpanelProperties.NEW_ACCOUNT_METATRADER_ID]: newWetatraderID ?? '-',
      ...userAccountProperties
    });
  };
}

const pageAnalysisService = new PageAnalysisService();
export default pageAnalysisService;
